/// <reference types="@angular/localize" />

import { registerLocaleData } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import localeTh from '@angular/common/locales/th';

registerLocaleData(localeTh);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
